import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import styled from 'styled-components';
import {
  Title, Subtitle, Panel, ScrollBox,
} from '.';

const AnimatedFlex = styled(Flex)`
  transition: ${(props) => props.theme.animation.slow};
`;

const List = styled(Box)`
  max-height: 422px;
  overflow: auto;
`;

function Layout(props) {
  const {
    title,
    layoutItems,
    configPanel,
    layoutButtons,
    configButtons,
    modal,
    subtitle,
    header,
    headerButtons,
    isEditing,
  } = props;

  return (
    <Box>
      {modal}
      {(title || subtitle) && (
        <Box mb={3}>
          {title && (
            <Title fontSize={4} fontWeight={300} mb={3}>
              {title}
            </Title>
          )}
          {subtitle && <Subtitle mb={4}>{subtitle}</Subtitle>}
        </Box>
      )}
      {header && <Panel mb={2}>{header}</Panel>}
      {headerButtons}
      <Flex>
        <AnimatedFlex flex={1} mr={2} flexDirection="column">
          {layoutButtons && <Flex mb={3}>{layoutButtons}</Flex>}
          <List>
            <ScrollBox pr={3}>
              {layoutItems}
            </ScrollBox>
          </List>
        </AnimatedFlex>
        <AnimatedFlex flex={isEditing ? 4 : [1, 1, 1, 2]} ml={2} flexDirection="column">
          {configButtons && (
            <Flex mb={3} justifyContent="flex-end">
              {configButtons}
            </Flex>
          )}
          {configPanel && (
            <Box>
              <Panel ml={2}>
                {configPanel}
              </Panel>
            </Box>
          )}
        </AnimatedFlex>
      </Flex>
    </Box>
  );
}

Layout.defaultProps = {
  header: undefined,
  headerButtons: undefined,
  layoutButtons: undefined,
  configButtons: undefined,
  modal: undefined,
  configPanel: undefined,
  title: undefined,
  subtitle: undefined,
  layoutItems: [],
  isEditing: false,
};

Layout.propTypes = {
  header: PropTypes.node,
  headerButtons: PropTypes.node,
  modal: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  layoutItems: PropTypes.array,
  layoutButtons: PropTypes.object,
  configPanel: PropTypes.object,
  configButtons: PropTypes.object,
  isEditing: PropTypes.bool,
};

export default Layout;
